"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../css/notification_badge.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationBadge = function NotificationBadge(_ref) {
  var children = _ref.children,
      position = _ref.position,
      value = _ref.value;
  var top = false;
  var bottom = false;
  var right = false;
  var left = false;

  switch (position) {
    case 'top-left':
      top = true;
      left = true;
      break;

    case 'bottom-right':
      bottom = true;
      right = true;
      break;

    case 'bottom-left':
      bottom = true;
      left = true;
      break;

    default:
      // top-right
      top = true;
      right = true;
      break;
  }

  var classes = (0, _classnames.default)({
    'vn-notification': true,
    'vn-notification--lt-10': value < 10,
    'vn-notification--lt-100': value >= 10 && value < 100,
    'vn-notification--lt-1000': value >= 100 && value < 1000,
    'vn-notification--gt-1000': value >= 1000
  });
  var targetClasses = (0, _classnames.default)({
    'vn-notification__target': true,
    'vn-notification__target--top': top,
    'vn-notification__target--bottom': bottom,
    'vn-notification__target--right': right,
    'vn-notification__target--left': left
  });
  var badgeClasses = (0, _classnames.default)({
    'vn-notification__badge': true,
    'vn-notification__badge--gt-10': value >= 10,
    'vn-notification__badge--top': top,
    'vn-notification__badge--bottom': bottom,
    'vn-notification__badge--right': right,
    'vn-notification__badge--left': left
  });
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("div", {
    className: targetClasses
  }, children), _react.default.createElement("div", {
    className: badgeClasses
  }, value));
};

NotificationBadge.propTypes = {
  children: _propTypes.default.node.isRequired,
  position: _propTypes.default.oneOf(['top-right', 'top-left', 'bottom-right', 'bottom-left']),
  value: _propTypes.default.node.isRequired
};
NotificationBadge.defaultProps = {
  position: 'top-right'
};
NotificationBadge.displayName = 'NotificationBadge';
var _default = NotificationBadge;
exports.default = _default;